// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3z3bM","errors":"Errors_errors__2Lzzq"};